import clsx from 'clsx'
import { HugeiconsIcon } from '@hugeicons/react'

import { CheckmarkSquare02Icon } from '@hugeicons/core-solid-rounded'
import { SquareIcon } from '@hugeicons/core-stroke-rounded'

type Props = React.PropsWithChildren<
  React.InputHTMLAttributes<HTMLInputElement>
> & {
  invalid?: boolean
}

export default function Checkbox({
  children,
  readOnly = false,
  invalid = false,
  ...rest
}: Props) {
  return (
    <label
      className={clsx(
        'flex cursor-pointer flex-row gap-2 rounded-[5px]',
        readOnly && 'pointer-events-none',
        invalid && 'border-red-500'
      )}
    >
      <input
        type="checkbox"
        {...rest}
        readOnly={readOnly}
        disabled={readOnly}
        aria-invalid={invalid}
        className="-mr-2 appearance-none"
      />
      {rest.checked && (
        <HugeiconsIcon icon={CheckmarkSquare02Icon} className="text-primary" />
      )}
      {!rest.checked && (
        <HugeiconsIcon icon={SquareIcon} className="text-primary" />
      )}
      {children}
    </label>
  )
}
